import { Maybe } from "graphql/jsutils/Maybe";
import { create } from "zustand";
import { getCategory } from "./mail-item-category";
import { IMailItem } from "./mail-item-types";
import { wrapMailItem } from "./wrapped-mail-item";

type ItemStore = {
  initialised: boolean;
  updateTs: number;
  wrappedMailItem: Maybe<IMailItem>;
  userProfile: Maybe<Office.UserProfile>;
  updateProfile: (userProfile: Maybe<Office.UserProfile>) => void;
  updateItem: (item: Promise<Maybe<IMailItem>>) => Promise<void>;
  setInitialised: () => void;
};

export const useItemStore = create<ItemStore>((set) => ({
  initialised: false,
  updateTs: 0,
  wrappedMailItem: undefined,
  userProfile: undefined,
  updateProfile: (userProfile) => {
    set(() => ({ userProfile, updateTs: Date.now() }));
  },
  updateItem: async (wrappedMailItem): Promise<void> => {
    const item = await wrappedMailItem;

    set(() => ({ wrappedMailItem: item, updateTs: Date.now() }));
    if (item) {
      console.log("Now tracking mail item:", item.itemId);
    } else {
      console.log("No mail item to track");
    }
  },
  setInitialised: () => {
    set(() => ({ initialised: true }));
  },
}));

export const updateItemStoreFromOffice = async () => {
  useItemStore.getState().updateProfile(Office.context.mailbox.userProfile);
  await useItemStore.getState().updateItem(wrapMailItem(Office.context.mailbox, getCategory("Smokeball")));
};
